import { render, staticRenderFns } from "./field-show.vue?vue&type=template&id=3f7267c1&"
import script from "./field-show.vue?vue&type=script&lang=ts&"
export * from "./field-show.vue?vue&type=script&lang=ts&"
import style0 from "./field-show.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports